module.exports = __webpack_public_path__ + "static/media/07_tn.8c20c641.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/07_tn.jpg
// module id = 643
// module chunks = 0